export default __webpack_public_path__ + "static/media/rnr-sports-table-6-cn.00e38ffe.webp";